import React from 'react';
import { CoreLink } from '@uncinc/react-drupal-core';
import { Container } from '@uncinc/uncinc-react-kitchen-sink';
import config from 'react-global-configuration';

import { DOMAIN_VNL } from '../../config/constants';

import './style.scss';

const Tags = ({ subjects, workfields, phasesOfLife, locations }) => {
  const domainIsVNL = config.get('CURRENT_DOMAIN') === DOMAIN_VNL;

  if (!domainIsVNL) return null;

  return (
    <Container className="Tags">
      <div className="row">
        <div className="col-12 col-lg-8 offset-lg-2">
          {subjects && subjects.size > 0 && (
            <div className="Tags__section Tags__section__subjects">
              <p>Meer over onderwerpen:</p>
              <div className="Tags__subjects">
                {subjects.map((subject) => {
                  const subjectTitle = subject.getIn(['entity', 'name', 0, 'value']);
                  const tagType = subject.getIn(['entity', 'vid', 0, 'target_id']);
                  const url = subject.getIn(['entity', 'paths', 'nl'], subject.getIn(['url']));
                  const subjectId = subject.getIn(['target_id']);
                  const uuid = subject.getIn(['entity', 'uuid', 0, 'value']);

                  if (subjectTitle) {
                    return (
                      <CoreLink to={url} key={uuid}>
                        <span
                          className={`NodeMetadata__subjects__subject ${tagType}`}
                          key={`${subjectTitle}-${subjectId}`}
                        >
                          {subjectTitle}
                        </span>
                      </CoreLink>
                    );
                  }
                })}
              </div>
            </div>
          )}

          {workfields && workfields.size > 0 && (
            <div className="Tags__section">
              <p>Meer voor werkvelden:</p>
              <div className="Tags__workfields">
                {workfields.map((workfield) => {
                  const workfieldTitle = workfield.getIn(['entity', 'name', 0, 'value']);
                  const tagType = workfield.getIn(['entity', 'vid', 0, 'target_id']);
                  const url = workfield.getIn(['entity', 'paths', 'nl'], workfield.getIn(['url']));
                  const subjectId = workfield.getIn(['target_id']);
                  const uuid = workfield.getIn(['entity', 'uuid', 0, 'value']);

                  if (workfieldTitle) {
                    return (
                      <CoreLink to={url} key={uuid}>
                        <span
                          className={`NodeMetadata__subjects__subject ${tagType}`}
                          key={`${workfieldTitle}-${subjectId}`}
                        >
                          {workfieldTitle}
                        </span>
                      </CoreLink>
                    );
                  }
                })}
              </div>
            </div>
          )}

          {phasesOfLife && phasesOfLife.size > 0 && (
            <div className="Tags__section">
              <p>Meer over levensfases:</p>
              <div className="Tags__phasesoflife">
                {phasesOfLife.map((phaseOfLife) => {
                  const phaseOfLifeTitle = phaseOfLife.getIn(['entity', 'name', 0, 'value']);
                  const tagType = phaseOfLife.getIn(['entity', 'vid', 0, 'target_id']);
                  const url = phaseOfLife.getIn(['entity', 'paths', 'nl'], phaseOfLife.getIn(['url']));
                  const subjectId = phaseOfLife.getIn(['target_id']);
                  const uuid = phaseOfLife.getIn([
                    'entity',
                    'uuid',
                    0,
                    'value',
                  ]);

                  if (phaseOfLifeTitle) {
                    return (
                      <CoreLink to={url} key={uuid}>
                        <span
                          className={`NodeMetadata__subjects__subject ${tagType}`}
                          key={`${phaseOfLifeTitle}-${subjectId}`}
                        >
                          {phaseOfLifeTitle}
                        </span>
                      </CoreLink>
                    );
                  }
                })}
              </div>
            </div>
          )}

          {locations && locations.size > 0 && (
            <div className="Tags__section">
              <p>Meer locaties:</p>
              <div className="Tags__workfields">
                {locations.map((location) => {
                  const locationTitle = location.getIn(['entity', 'name', 0, 'value']);
                  const tagType = location.getIn(['entity', 'vid', 0, 'target_id']);
                  const url = location.getIn(['entity', 'paths', 'nl'], location.getIn(['url']));
                  const subjectId = location.getIn(['target_id']);
                  const uuid = location.getIn(['entity', 'uuid', 0, 'value']);

                  if (locationTitle) {
                    return (
                      <CoreLink to={url} key={uuid}>
                        <span
                          className={`NodeMetadata__subjects__subject ${tagType}`}
                          key={`${locationTitle}-${subjectId}`}
                        >
                          {locationTitle}
                        </span>
                      </CoreLink>
                    );
                  }
                })}
              </div>
            </div>
          )}
        </div>
      </div>
    </Container>
  );
};

export default Tags;
